(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["psyours-card-alignment"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame;
    function alignTitles() {
      frame = null;
      document.querySelectorAll('.shopify-section').forEach(section => {
        const titles = [...section.querySelectorAll('.product-card-wrapper .card__heading')]
          .filter(title => title.getBoundingClientRect().width > 0 && title.getBoundingClientRect().height > 0);
        if (!titles.length) return;
        titles.forEach(title => title.style.removeProperty('--psyours-title-height'));
        const height = Math.ceil(Math.max(...titles.map(title => title.getBoundingClientRect().height)));
        titles.forEach(title => title.style.setProperty('--psyours-title-height', height + 'px'));
      });
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(alignTitles);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
    else schedule();
    if (document.fonts) document.fonts.ready.then(schedule);
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('shopify:section:load', schedule);
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches('.product-card-wrapper') || node.querySelector('.product-card-wrapper'))
      ))) schedule();
    }).observe(document.body, {childList:true, subtree:true});
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psyours-conversion"] && !Shopify.designMode) return;
  try {
    (()=>{
const syncShipping=()=>document.querySelectorAll('[data-product-shipping]').forEach(note=>{
 const scope=note.closest('section')||document;
 const id=scope.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
 const variant=JSON.parse(note.dataset.variants).find(v=>String(v.id)===id);
 if(variant)note.textContent=note.dataset.currency==='USD'&&variant.price>=15000?note.dataset.free:note.dataset.standard;
});
document.addEventListener('change',event=>{if(event.target.closest('variant-selects,[data-psyours-engraving]')){setTimeout(syncShipping,300);setTimeout(syncShipping,1200);}});
document.addEventListener('change',event=>{if(event.target.closest('.psyours-cart-editor'))event.stopImmediatePropagation();},true);
document.addEventListener('input',event=>{if(event.target.closest('.psyours-cart-editor'))event.stopImmediatePropagation();},true);
document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches('.psyours-cart-editor input')){event.preventDefault();event.stopImmediatePropagation();event.target.closest('.psyours-cart-editor').querySelector('[data-save-engraving]').click();}},true);
document.addEventListener('click',async event=>{
 const button=event.target.closest('[data-save-engraving]');if(!button)return;
 const editor=button.closest('.psyours-cart-editor'),input=editor.querySelector('[data-edit-text]'),font=editor.querySelector('[data-edit-font]'),status=editor.querySelector('[data-edit-status]');
 if(!input.value.trim()||Array.from(input.value).length>10||!font.value){status.textContent=editor.dataset.invalid;input.focus();return;}
 const original=button.textContent;button.disabled=true;status.textContent=editor.dataset.saving;
 try{
  const root=window.Shopify?.routes?.root||'/';
  const currentResponse=await fetch(root+'cart.js',{headers:{'Accept':'application/json'}});if(!currentResponse.ok)throw new Error('cart unavailable');
  const current=await currentResponse.json(),line=current.items.find(item=>item.key===editor.dataset.key);if(!line)throw new Error('cart changed');
  const properties={...line.properties};properties['Engraving text']=input.value;properties['Engraving font']=font.value;
  const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.key,quantity:line.quantity,properties})});
  const result=await response.json();if(!response.ok||result.status>=400)throw new Error('change failed');
  status.textContent=editor.dataset.success;window.location.assign(root+'cart');
 }catch(error){status.textContent=editor.dataset.error;button.disabled=false;button.textContent=original;}
});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psyours-product-details"] && !Shopify.designMode) return;
  try {
    (function () {
  var DURATION = 300;
  var EASING = 'ease';

  function animateHeight(details, body, from, to, onFinish) {
    if (details.psyoursAnimation) details.psyoursAnimation.cancel();
    var animation = body.animate(
      [{ height: from }, { height: to }],
      { duration: DURATION, easing: EASING }
    );
    details.psyoursAnimation = animation;
    animation.onfinish = function () {
      details.psyoursAnimation = null;
      body.style.height = '';
      if (onFinish) onFinish();
    };
    animation.oncancel = function () {
      body.style.height = '';
    };
  }

  function closeDetail(details) {
    var body = details.querySelector('.psyours-detail__body');
    if (!body || !details.hasAttribute('open')) return;
    var startHeight = body.getBoundingClientRect().height + 'px';
    animateHeight(details, body, startHeight, '0px', function () {
      details.removeAttribute('open');
    });
  }

  function openDetail(details) {
    var body = details.querySelector('.psyours-detail__body');
    if (!body) { details.setAttribute('open', ''); return; }
    details.setAttribute('open', '');
    var endHeight = body.getBoundingClientRect().height + 'px';
    animateHeight(details, body, '0px', endHeight);
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.classList.contains('psyours-detail')) return;
    event.preventDefault();

    var wasOpen = details.hasAttribute('open');
    if (wasOpen) {
      closeDetail(details);
    } else {
      document.querySelectorAll('.psyours-detail[open]').forEach(function (el) {
        if (el !== details) closeDetail(el);
      });
      openDetail(details);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psyours-shopping-experience"] && !Shopify.designMode) return;
  try {
    (() => {
 const start = () => {
  const copy = document.getElementById('psyours-shopping-copy');
  document.querySelectorAll('[data-psyours-engraving]').forEach(root => {
   if(root.dataset.shoppingReady) return;
   root.dataset.shoppingReady='true';
   const text=root.querySelector('input[type=text]'),font=root.querySelector('select');
   const yes=root.querySelector('input[type=radio][value=Yes]'),no=root.querySelector('input[type=radio][value=No]');
   const info=root.closest('product-info');
   if(!text||!font||!yes||!no||!info) return;
   const error=document.createElement('p');error.className='psyours-engraving-error';error.id=`${text.id}-error`;error.setAttribute('role','alert');error.hidden=true;root.append(error);
   text.setAttribute('aria-describedby',error.id);font.setAttribute('aria-describedby',error.id);
   const tag=info.querySelector('variant-selects select[name="options[Silver Name Tag]"],variant-selects select[name="options[Engraved Silver Tag]"]');
   let yesValue,noValue;
   if(tag){
    noValue=Array.from(tag.options).find(o=>/^(No Silver Name Tag|No engraved tag)$/i.test(o.value))?.value;
    yesValue=Array.from(tag.options).find(o=>/^(Add Custom Engraved Silver Name Tag|Add engraved silver tag)/i.test(o.value))?.value;
    if(yesValue&&noValue){
     yes.checked=tag.value===yesValue;no.checked=!yes.checked;
     (yes.checked?yes:no).dispatchEvent(new Event('change',{bubbles:true}));
     tag.closest('.product-form__input').classList.add('psyours-option-hidden');
     root.addEventListener('change',e=>{
      if(e.target!==yes&&e.target!==no)return;
      const value=yes.checked?yesValue:noValue;
      if(tag.value!==value){tag.value=value;tag.dispatchEvent(new Event('change',{bubbles:true}));}
     });
    }
   }
   const validate = () => {
    text.setCustomValidity('');
    if(yes.checked&&!text.value.trim())text.setCustomValidity(copy?.dataset.engravingLetters||'Enter at least one character.');
    const invalid=yes.checked?(!text.checkValidity()?text:!font.checkValidity()?font:null):null;
    error.hidden=!invalid;
    if(invalid){error.textContent=invalid===text?copy?.dataset.engravingLetters:copy?.dataset.engravingError;invalid.setAttribute('aria-invalid','true');root.scrollIntoView({block:'center'});const target=invalid===font?root.querySelector('[data-font-value]'):invalid;(target||invalid).focus();if(target===invalid)invalid.reportValidity();return false;}
    text.removeAttribute('aria-invalid');font.removeAttribute('aria-invalid');return true;
   };
   root.addEventListener('input',()=>{text.setCustomValidity('');text.removeAttribute('aria-invalid');font.removeAttribute('aria-invalid');error.hidden=true;});
   root.addEventListener('change',()=>{if(!yes.checked){error.hidden=true;text.setCustomValidity('');}});
   const guard=e=>{if(!validate()){e.preventDefault();e.stopImmediatePropagation();}};
   // The legacy sticky button calls its handler directly, so validate at capture phase.
   document.addEventListener('click',e=>{
    const button=e.target.closest('button');
    if(button&&!button.disabled&&button.getAttribute('form')===text.getAttribute('form')&&(button.classList.contains('main-product-atc')||button.type==='submit'))guard(e);
   },true);
   const form=document.getElementById(text.getAttribute('form'));form?.addEventListener('submit',guard,true);
  });
  document.querySelectorAll('.footer-block--menu').forEach(block => {
   if(block.querySelector('.psyours-footer-menu'))return;
   const heading=block.querySelector('.footer-block__heading'),list=block.querySelector('ul');
   if(!heading||!list)return;
   const details=document.createElement('details'),summary=document.createElement('summary');
   details.className='psyours-footer-menu';summary.append(heading);details.append(summary,list);block.append(details);
   const media=window.matchMedia('(max-width:749px)');
   const resize=()=>{details.open=!media.matches;};resize();media.addEventListener('change',resize);
   summary.addEventListener('click',event=>{if(!media.matches)event.preventDefault();});
  });
  document.querySelectorAll('variant-selects .product-form__input').forEach(group=>{
   if(group.dataset.fixedReady)return;
   const select=group.querySelector('select');
   if(select&&select.options.length===1){
    const label=group.querySelector('.form__label')?.textContent.trim()||'';
    const summary=document.createElement('p');summary.className='psyours-fixed-option';summary.textContent=`${label}: ${select.options[0].value}`;
    group.after(summary);group.classList.add('psyours-option-hidden');group.dataset.fixedReady='true';
   }
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
 document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psyours-slideshow-stability"] && !Shopify.designMode) return;
  try {
    (() => {
 function setup(root) {
  root.querySelectorAll('slideshow-component .slideshow').forEach(slider => {
   if (slider.dataset.psyoursSnapReady) return;
   slider.dataset.psyoursSnapReady='true';
   let timer, dragging=false, active=0, width=slider.clientWidth;
   const slides=()=>[...slider.querySelectorAll('.slideshow__slide')];
   const offset=slide=>slide.offsetLeft-slides()[0].offsetLeft;
   function settle() {
    if(dragging) return;
    const items=slides();if(!items.length)return;
    active=items.reduce((best,slide,i)=>Math.abs(offset(slide)-slider.scrollLeft)<Math.abs(offset(items[best])-slider.scrollLeft)?i:best,0);
    const target=offset(items[active]);
    if(Math.abs(slider.scrollLeft-target)>1)slider.scrollTo({left:target,behavior:'instant'});
   }
   slider.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(settle,200);},{passive:true});
   slider.addEventListener('pointerdown',()=>{dragging=true;},{passive:true});
   ['pointerup','pointercancel','touchend'].forEach(event=>slider.addEventListener(event,()=>{dragging=false;clearTimeout(timer);timer=setTimeout(settle,200);},{passive:true}));
   new ResizeObserver(()=>{if(width===slider.clientWidth)return;width=slider.clientWidth;const items=slides();if(items[active])slider.scrollTo({left:offset(items[active]),behavior:'instant'});}).observe(slider);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document),{once:true});else setup(document);
 document.addEventListener('shopify:section:load',event=>setup(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
